/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

import { createEnv } from '@t3-oss/env-core'
import { z } from 'zod/v4'

const DEFAULT_HOST = 'https://n.bacapibo.com'
const DEFAULT_UI_HOST = 'https://us.posthog.com'

/**
 * Server-side PostHog env contract (Fastify api, Trigger.dev jobs, Next server
 * actions). Reads the SAME NEXT_PUBLIC_ keys the browser uses — PostHog's ingest
 * key is public by design, so one value serves both client and server. Optional:
 * a missing key disables analytics (no-op) instead of crashing.
 *
 * These are declared as server vars here (read from process.env on the server).
 * Browser bundles can't read them via `extends` — Next only inlines client vars
 * each app lists in its own `experimental__runtimeEnv` — so each app also
 * declares NEXT_PUBLIC_POSTHOG_KEY/HOST in its own env.ts for the client side.
 */
export function analyticsEnv() {
  return createEnv({
    server: {
      NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
      NEXT_PUBLIC_POSTHOG_HOST: z.url().default(DEFAULT_HOST),
      NEXT_PUBLIC_POSTHOG_UI_HOST: z.url().default(DEFAULT_UI_HOST),
      // Build time only, on Vercel: uploads web/school/account source maps to Error Tracking.
      POSTHOG_PERSONAL_API_KEY: z.string().optional(),
    },
    clientPrefix: 'NEXT_PUBLIC_',
    client: {
      NEXT_PUBLIC_POSTHOG_KEY: z.string().optional(),
      NEXT_PUBLIC_POSTHOG_HOST: z.url().default(DEFAULT_HOST),
      NEXT_PUBLIC_POSTHOG_UI_HOST: z.url().default(DEFAULT_UI_HOST),
    },
    runtimeEnv: process.env,
    skipValidation:
      !!process.env.CI ||
      process.env.npm_lifecycle_event === 'lint' ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      typeof (globalThis as any).window !== 'undefined', // Skip in browser
  })
}
